import React, {useState, useContext} from 'react';
import {
  Card,
  CardBoldText,
  LinkContainer,
  LinkSpace
} from 'app/src/elements';
import { Text, Pressable, View } from 'react-native';
import Modal from './Modal';
import EditContact from '../components/Contacts/edit';
import { useMutation } from '@apollo/client';
import { HIDE_CONTACT } from '../components/Contacts/queries';
import AuthContext from '../contexts/AuthContext';

const ContactCard = props => {
  const { hasPolicy } = useContext(AuthContext);
  const { contact, setShowModal, setUpdatedContactDetails } = props;
  const [showEditContactModal, setShowEditContactModal] = useState(false);

  const [hideContact] = useMutation(HIDE_CONTACT, {
    onCompleted: (response) => {
      // navigate(`/sellers${sellerId}`);
      // setShowModal(false);
      setUpdatedContactDetails(response?.hideContact?.contact, false, true)
    }
  });

  const onHide = () => {
    hideContact({ variables: {id: contact.id} });
  }

  return (
    <Card>
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          flex: 1,
          justifyContent: 'space-between'
        }}
      >
        <CardBoldText>{`${contact.firstName} ${contact.lastName}`}</CardBoldText>
        {contact.primary &&
          <CardBoldText>
            Primary
          </CardBoldText>
        }
      </View>
      {contact.title &&
        <CardBoldText>{contact.title}</CardBoldText>
      }
      <Text>{contact.phoneNumber.formatted}</Text>
      <Text>{contact.email}</Text>
      <LinkContainer style={{marginTop: '20px', justifyContent: 'flex-end'}}>
        <Pressable
          onPress={() => setShowEditContactModal(true)}
          style={{alignSelf: 'flex-end'}}
        >
          <Text>
            edit
          </Text>
        </Pressable>
        {hasPolicy({ type: 'Contact', action: 'hide' }) && (
          <View>
            <LinkSpace />
            <Pressable
              onPress={() => window.confirm('Hide Contact?', onHide())}
              style={{alignSelf: 'flex-end'}}
            >
              <Text>hide</Text>
            </Pressable>
          </View>
        )}
      </LinkContainer>
      {showEditContactModal &&
        <Modal
          contact={contact}
          showModal={showEditContactModal}
          setShowModal={setShowEditContactModal}
          modalType={'Edit Contact'}
          objectName={`${contact.firstName ? contact.firstName : ''}
            ${contact.lastName ? ' ' + contact.lastName : ''}
          `}
        >
          <EditContact
            setShowModal={setShowEditContactModal}
            contactDetails={contact}
            setUpdatedContactDetails={setUpdatedContactDetails}
          />
        </Modal>
      }
    </Card>
  )
}

export default ContactCard;
